let globalZIndex = 10000;

export function getNextZIndex(){
    globalZIndex += 1
    return globalZIndex
}

export function resetZIndex(){
    globalZIndex = 10000;
}